// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductXSell_container__Baqpd","header":"ProductXSell_header__b6WN7","title":"ProductXSell_title__5Esca","seeAllLink":"ProductXSell_seeAllLink__5CFVD"};